import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const CONNECTED_ACTIVITIES_MODULE = 'CONNECTED_ACTIVITIES';

export const DEFAULT_CONNECTED_ACTIVITIES_COLUMNS: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'title',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'city',
    field_name: 'CITY',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'provider-update',
    field_name: 'PROVIDER_UPDATE',
    checked: true,
    order_by: 'og_updated',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'product-code',
    field_name: 'PRODUCT_CODE',
    checked: true,
    order_by: 'product_code',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'provider',
    field_name: 'PROVIDER',
    checked: true,
    order_by: 'provider__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: true,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-agency',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'activated',
    field_name: 'ACTIVATED',
    checked: true,
    order_by: 'deactivated',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const setConnectedActivitiesPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: CONNECTED_ACTIVITIES_MODULE, default_columns: DEFAULT_CONNECTED_ACTIVITIES_COLUMNS, default_order_by: 'title', default_order: 'asc' });
